import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isoWeek);

export const resetTime = (date) => {
  return new Date(date?.getFullYear(), date?.getMonth(), date?.getDate());
};

export const staticRanges = [
  { key: 'today', label: 'Today', value: [dayjs().startOf('day'), dayjs().endOf('day')] },
  {
    key: 'yesterday',
    label: 'Yesterday',
    value: [dayjs().subtract(1, 'day').startOf('day'), dayjs().subtract(1, 'day').endOf('day')],
  },
  {
    key: 'this_week',
    label: 'This Week',
    value: [dayjs().startOf('isoWeek'), dayjs().endOf('isoWeek')],
  },
  {
    key: 'last_week',
    label: 'Last Week',
    value: [
      dayjs().subtract(1, 'week').startOf('isoWeek'),
      dayjs().subtract(1, 'week').endOf('isoWeek'),
    ],
  },
  {
    key: 'last_7_days',
    label: 'Last 7 Days',
    value: [dayjs().subtract(7, 'day').startOf('day'), dayjs().endOf('day')],
  },
  {
    key: 'last_14_days',
    label: 'Last 14 Days',
    value: [dayjs().subtract(14, 'day').startOf('day'), dayjs().endOf('day')],
  },
  {
    key: 'last_30_days',
    label: 'Last 30 Days',
    value: [dayjs().subtract(30, 'day').startOf('day'), dayjs().endOf('day')],
  },
  {
    key: 'this_month',
    label: 'This Month',
    value: [dayjs().startOf('month'), dayjs().endOf('month')],
  },
  {
    key: 'last_month',
    label: 'Last Month',
    value: [
      dayjs().subtract(1, 'month').startOf('month'),
      dayjs().subtract(1, 'month').endOf('month'),
    ],
  },
  {
    key: 'this_year',
    label: 'This Year',
    value: [dayjs().startOf('year'), dayjs().endOf('year')],
  },
  {
    key: 'last_year',
    label: 'Last Year',
    value: [dayjs().subtract(1, 'year').startOf('year'), dayjs().subtract(1, 'year').endOf('year')],
  },
];

export const getDateRangeByKey = (key) => {
  const rangeConfig = staticRanges.find((range) => range.key === key);
  if (rangeConfig) {
    const [startDate, endDate] = rangeConfig.value;

    return {
      label: rangeConfig.label,
      date_from: startDate.format('YYYY-MM-DD'),
      date_to: endDate.format('YYYY-MM-DD'),
    };
  }
  return { label: null, date_from: null, date_to: null };
};
